module.exports = __webpack_public_path__ + "img/question-icon-3.04298d3c.png";